import React from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import css from '../Footer/Footer.module.css';

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.openForm = this.openForm.bind(this);
  }

  openForm() {
    this.typeformEmbed.typeform.open();
  }

  render() {
    return (
      <div>
        <ReactTypeformEmbed
          popup={true}
          mode={'drawer_right'}
          autoOpen={false}
          url="https://form.typeform.com/to/j34rjmEk"
          hideHeaders
          hideFooter
          style={{ top: 100, width: '100px' }}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
        />
        <p onClick={this.openForm} className={css.link}>
          Feedback Form
        </p>
      </div>
    );
  }
}

export default Feedback;
